import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { QuoteWithRegulation } from 'state/quotes/results/result.model';
import type { IHttpClient } from 'utils/http/httpClient.model';

export interface FetchDynamicLastQuoteApi {
  getLastQuote(rfqId: string): Observable<QuoteWithRegulation>;
}

export const dynamicLastQuoteApi = (http: IHttpClient): FetchDynamicLastQuoteApi => ({
  getLastQuote(rfqId) {
    return http
      .getJSON<QuoteWithRegulation>({
        url: `api/v1/dynamic-quote/${rfqId}/last/price`,
      })
      .pipe(map(r => r.payload));
  },
});
